import React from 'react';
import {H1} from "../../components/titles/titles";
import styles from "./TransactionAntigoonScreen.module.css";
import globalStyles from "../../styles/styles.module.css";
import FieldsPane, {FieldsCol} from "../../components/FieldsPane/FieldsPane";
import Field from "../../components/Field/Field";
import ItemNoResults from "../../components/ItemNoResults/ItemNoResults";
import PaymentStatusAmount from "../../components/PaymentStatusAmount/PaymentStatusAmount";

type Props = {
    transaction: TransactionAntigoonType | null | undefined;
};

const TransactionAntigoonScreen = ({
                               transaction,
                           }: Props) => {
    return (
        <div>
            <div className={styles.titleWrapper}>
                <H1>Transaction</H1>
            </div>
            {transaction && <TransactionScreenContents transaction={transaction}/>}
            {transaction === null && <ItemNoResults/>}
        </div>
    );
};

type TransactionScreenContentsProps = {
    transaction: TransactionAntigoonType;
};

const TransactionScreenContents = ({transaction}: TransactionScreenContentsProps) => {
    const {
        amount,
        communication,
        state,
        paymentDate,
        paymentMethodScheme,
        customerId,
        referenceId,
        channel,
        customerIban,
        customerBic,
        documentNumber,
    } = transaction;

    return (
        <>
            <div className={styles.primaryFieldsWrapper}>
                <FieldsPane>
                    <FieldsCol>
                        <Field label="Communication" children={communication}/>
                        <Field label="Payment method" children={paymentMethodScheme}/>
                    </FieldsCol>
                    <FieldsCol>
                        <PaymentStatusAmount status={state} amount={amount}/>
                        <div className={globalStyles.detailsRightWrapper}>
                            <div>Transaction date: {paymentDate}</div>
                        </div>
                    </FieldsCol>
                </FieldsPane>
            </div>
            <FieldsPane>
                <FieldsCol>
                    <Field label="Customer Id" children={customerId}/>
                    <Field label="Customer IBAN" children={customerIban}/>
                    <Field label="Document Id" children={documentNumber}/>
                </FieldsCol>
                <FieldsCol>
                    <Field label="Channel" children={channel}/>
                    <Field label="Customer BIC" children={customerBic}/>
                </FieldsCol>
            </FieldsPane>
            <div className={globalStyles.primaryID}>
                <span>POM Transaction Id: </span>
                {referenceId}
            </div>
        </>
    );
};

export default TransactionAntigoonScreen;
